import Integrations_Datasets_AdminDatasetDetailsPage from "@Integrations/Datasets/Pages/AdminDatasetDetailsPage.vue";
import Integrations_Datasets_AdminManageDatasetsPage from "@Integrations/Datasets/Pages/AdminManageDatasetsPage.vue";

export const routes = [
    // admin pages
    {
        path: "/admin/integrations/datasets/details/:id",
        component: Integrations_Datasets_AdminDatasetDetailsPage
    },
    {
        path: "/admin/integrations/datasets/manage/:tid",
        component: Integrations_Datasets_AdminManageDatasetsPage
    },
]
